import { Spinner } from './LoadingSpinner.styles';

const LoadingSpinner = () => <Spinner />;

export default LoadingSpinner;
